import ownDesign1Fallback from '@/assets/images/company-gifts/gallery/own-design-1.jpg?w=600'
import ownDesign1Avif from '@/assets/images/company-gifts/gallery/own-design-1.jpg?w=600&format=avif&as=srcset'
import ownDesign1Webp from '@/assets/images/company-gifts/gallery/own-design-1.jpg?w=600&format=webp&as=srcset'
import ownDesign2Fallback from '@/assets/images/company-gifts/gallery/own-design-2.jpg?w=600'
import ownDesign2Avif from '@/assets/images/company-gifts/gallery/own-design-2.jpg?w=600&format=avif&as=srcset'
import ownDesign2Webp from '@/assets/images/company-gifts/gallery/own-design-2.jpg?w=600&format=webp&as=srcset'
import ownDesign3Fallback from '@/assets/images/company-gifts/gallery/own-design-3.jpg?w=600'
import ownDesign3Avif from '@/assets/images/company-gifts/gallery/own-design-3.jpg?w=600&format=avif&as=srcset'
import ownDesign3Webp from '@/assets/images/company-gifts/gallery/own-design-3.jpg?w=600&format=webp&as=srcset'
import ownDesign4Fallback from '@/assets/images/company-gifts/gallery/own-design-4.jpg?w=600'
import ownDesign4Avif from '@/assets/images/company-gifts/gallery/own-design-4.jpg?w=600&format=avif&as=srcset'
import ownDesign4Webp from '@/assets/images/company-gifts/gallery/own-design-4.jpg?w=600&format=webp&as=srcset'
import ownDesign5Fallback from '@/assets/images/company-gifts/gallery/own-design-5.jpg?w=600'
import ownDesign5Avif from '@/assets/images/company-gifts/gallery/own-design-5.jpg?w=600&format=avif&as=srcset'
import ownDesign5Webp from '@/assets/images/company-gifts/gallery/own-design-5.jpg?w=600&format=webp&as=srcset'
import ownDesign6Fallback from '@/assets/images/company-gifts/gallery/own-design-6.jpg?w=600'
import ownDesign6Avif from '@/assets/images/company-gifts/gallery/own-design-6.jpg?w=600&format=avif&as=srcset'
import ownDesign6Webp from '@/assets/images/company-gifts/gallery/own-design-6.jpg?w=600&format=webp&as=srcset'
import ownDesign7Fallback from '@/assets/images/company-gifts/gallery/own-design-7.jpg?w=600'
import ownDesign7Avif from '@/assets/images/company-gifts/gallery/own-design-7.jpg?w=600&format=avif&as=srcset'
import ownDesign7Webp from '@/assets/images/company-gifts/gallery/own-design-7.jpg?w=600&format=webp&as=srcset'

import threeSizesOfTubes1Fallback from '@/assets/images/company-gifts/gallery/three_sizes_of_tubes-1.jpg?w=600'
import threeSizesOfTubes1Avif from '@/assets/images/company-gifts/gallery/three_sizes_of_tubes-1.jpg?w=600&format=avif&as=srcset'
import threeSizesOfTubes1Webp from '@/assets/images/company-gifts/gallery/three_sizes_of_tubes-1.jpg?w=600&format=webp&as=srcset'
import threeSizesOfTubes2Fallback from '@/assets/images/company-gifts/gallery/three_sizes_of_tubes-2.jpg?w=600'
import threeSizesOfTubes2Avif from '@/assets/images/company-gifts/gallery/three_sizes_of_tubes-2.jpg?w=600&format=avif&as=srcset'
import threeSizesOfTubes2Webp from '@/assets/images/company-gifts/gallery/three_sizes_of_tubes-2.jpg?w=600&format=webp&as=srcset'

import mixitsWithCorporateDeposit1Fallback from '@/assets/images/company-gifts/gallery/mixits_with_corporate_deposit-1.jpg?w=600'
import mixitsWithCorporateDeposit1Avif from '@/assets/images/company-gifts/gallery/mixits_with_corporate_deposit-1.jpg?w=600&format=avif&as=srcset'
import mixitsWithCorporateDeposit1Webp from '@/assets/images/company-gifts/gallery/mixits_with_corporate_deposit-1.jpg?w=600&format=webp&as=srcset'

import giftPackage1Fallback from '@/assets/images/company-gifts/gallery/gift_package-1.jpg?w=600'
import giftPackage1Avif from '@/assets/images/company-gifts/gallery/gift_package-1.jpg?w=600&format=avif&as=srcset'
import giftPackage1Webp from '@/assets/images/company-gifts/gallery/gift_package-1.jpg?w=600&format=webp&as=srcset'
import giftPackage2Fallback from '@/assets/images/company-gifts/gallery/gift_package-2.jpg?w=600'
import giftPackage2Avif from '@/assets/images/company-gifts/gallery/gift_package-2.jpg?w=600&format=avif&as=srcset'
import giftPackage2Webp from '@/assets/images/company-gifts/gallery/gift_package-2.jpg?w=600&format=webp&as=srcset'
import giftPackage3Fallback from '@/assets/images/company-gifts/gallery/gift_package-3.jpg?w=600'
import giftPackage3Avif from '@/assets/images/company-gifts/gallery/gift_package-3.jpg?w=600&format=avif&as=srcset'
import giftPackage3Webp from '@/assets/images/company-gifts/gallery/gift_package-3.jpg?w=600&format=webp&as=srcset'
import giftPackage4Fallback from '@/assets/images/company-gifts/gallery/gift_package-4.jpg?w=600'
import giftPackage4Avif from '@/assets/images/company-gifts/gallery/gift_package-4.jpg?w=600&format=avif&as=srcset'
import giftPackage4Webp from '@/assets/images/company-gifts/gallery/gift_package-4.jpg?w=600&format=webp&as=srcset'

import otherCustomAreas1Fallback from '@/assets/images/company-gifts/gallery/other_custom_areas-1.jpg?w=600'
import otherCustomAreas1Avif from '@/assets/images/company-gifts/gallery/other_custom_areas-1.jpg?w=600&format=avif&as=srcset'
import otherCustomAreas1Webp from '@/assets/images/company-gifts/gallery/other_custom_areas-1.jpg?w=600&format=webp&as=srcset'
import otherCustomAreas2Fallback from '@/assets/images/company-gifts/gallery/other_custom_areas-2.jpg?w=600'
import otherCustomAreas2Avif from '@/assets/images/company-gifts/gallery/other_custom_areas-2.jpg?w=600&format=avif&as=srcset'
import otherCustomAreas2Webp from '@/assets/images/company-gifts/gallery/other_custom_areas-2.jpg?w=600&format=webp&as=srcset'
import otherCustomAreas3Fallback from '@/assets/images/company-gifts/gallery/other_custom_areas-3.jpg?w=600'
import otherCustomAreas3Avif from '@/assets/images/company-gifts/gallery/other_custom_areas-3.jpg?w=600&format=avif&as=srcset'
import otherCustomAreas3Webp from '@/assets/images/company-gifts/gallery/other_custom_areas-3.jpg?w=600&format=webp&as=srcset'

export const companyGiftsImages = [
  {
    name: 'own-design-1.jpg',
    avif: ownDesign1Avif,
    webp: ownDesign1Webp,
    fallback: ownDesign1Fallback,
  },
  {
    name: 'own-design-2.jpg',
    avif: ownDesign2Avif,
    webp: ownDesign2Webp,
    fallback: ownDesign2Fallback,
  },
  {
    name: 'own-design-3.jpg',
    avif: ownDesign3Avif,
    webp: ownDesign3Webp,
    fallback: ownDesign3Fallback,
  },
  {
    name: 'own-design-4.jpg',
    avif: ownDesign4Avif,
    webp: ownDesign4Webp,
    fallback: ownDesign4Fallback,
  },
  {
    name: 'own-design-5.jpg',
    avif: ownDesign5Avif,
    webp: ownDesign5Webp,
    fallback: ownDesign5Fallback,
  },
  {
    name: 'own-design-6.jpg',
    avif: ownDesign6Avif,
    webp: ownDesign6Webp,
    fallback: ownDesign6Fallback,
  },
  {
    name: 'own-design-7.jpg',
    avif: ownDesign7Avif,
    webp: ownDesign7Webp,
    fallback: ownDesign7Fallback,
  },
  {
    name: 'three-sizes-of-tubes-1.jpg',
    avif: threeSizesOfTubes1Avif,
    webp: threeSizesOfTubes1Webp,
    fallback: threeSizesOfTubes1Fallback,
  },
  {
    name: 'three-sizes-of-tubes-2.jpg',
    avif: threeSizesOfTubes2Avif,
    webp: threeSizesOfTubes2Webp,
    fallback: threeSizesOfTubes2Fallback,
  },
  {
    name: 'mixits-with-corporate-deposit-1.jpg',
    avif: mixitsWithCorporateDeposit1Avif,
    webp: mixitsWithCorporateDeposit1Webp,
    fallback: mixitsWithCorporateDeposit1Fallback,
  },
  {
    name: 'gift-package-1.jpg',
    avif: giftPackage1Avif,
    webp: giftPackage1Webp,
    fallback: giftPackage1Fallback,
  },
  {
    name: 'gift-package-2.jpg',
    avif: giftPackage2Avif,
    webp: giftPackage2Webp,
    fallback: giftPackage2Fallback,
  },
  {
    name: 'gift-package-3.jpg',
    avif: giftPackage3Avif,
    webp: giftPackage3Webp,
    fallback: giftPackage3Fallback,
  },
  {
    name: 'gift-package-4.jpg',
    avif: giftPackage4Avif,
    webp: giftPackage4Webp,
    fallback: giftPackage4Fallback,
  },
  {
    name: 'other-custom-areas-1.jpg',
    avif: otherCustomAreas1Avif,
    webp: otherCustomAreas1Webp,
    fallback: otherCustomAreas1Fallback,
  },
  {
    name: 'other-custom-areas-2.jpg',
    avif: otherCustomAreas2Avif,
    webp: otherCustomAreas2Webp,
    fallback: otherCustomAreas2Fallback,
  },
  {
    name: 'other-custom-areas-3.jpg',
    avif: otherCustomAreas3Avif,
    webp: otherCustomAreas3Webp,
    fallback: otherCustomAreas3Fallback,
  },
]